export default __webpack_public_path__ + "static/media/0025.a44aeec6.png";